import styles from './PlaylistWrapper.module.scss';

const PlaylistWrapper = ({
  children,
  tracklistExpanded,
  isMobile,
  isShowing,
  isTiny,
  onMouseEnter,
  onMouseLeave,
}) => {
  const className = `${styles.embedPlaylistApp} ${!isShowing ? styles.hidden : ''} ${
    isMobile ? styles.mobile : ''
  } ${tracklistExpanded ? styles.expanded : ''} ${isTiny ? styles.tiny : ''}`;

  return (
    <div className={className} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {children}
    </div>
  );
};

export default PlaylistWrapper;
